import PropTypes from "prop-types";
import "../assets/css/components.css";
import { useState } from "react";
import { MdExpandLess, MdExpandMore } from "react-icons/md";

export const CollapsibleContainer = ({
  title,
  element,
  setCollapsed = false,
}) => {
  const [isCollapsed, setIsCollapsed] = useState(setCollapsed);
  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <div className="grey-container">
      {isCollapsed ? (
        <div>
          {title}
          <div className="collapse-button" onClick={toggleCollapse}>
            Show <MdExpandMore />
          </div>
        </div>
      ) : (
        <div>
          {title}
          <div className="collapse-button" onClick={toggleCollapse}>
            Hide <MdExpandLess />
          </div>
          {element}
        </div>
      )}
    </div>
  );
};

CollapsibleContainer.propTypes = {
  title: PropTypes.string,
  element: PropTypes.element,
};
